/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Val_Sailing_YachtInputs */

const en_val_sailing_yacht = /** @type {(inputs: Val_Sailing_YachtInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sailing Yacht`)
};

const es_val_sailing_yacht = /** @type {(inputs: Val_Sailing_YachtInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Velero`)
};

const fr_val_sailing_yacht = /** @type {(inputs: Val_Sailing_YachtInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Voilier`)
};

const de_val_sailing_yacht = /** @type {(inputs: Val_Sailing_YachtInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Segelyacht`)
};

const ja_val_sailing_yacht = /** @type {(inputs: Val_Sailing_YachtInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`セーリングヨット`)
};

const zh_val_sailing_yacht = /** @type {(inputs: Val_Sailing_YachtInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`帆船游艇`)
};

const ar_val_sailing_yacht = /** @type {(inputs: Val_Sailing_YachtInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`يخت شراعي`)
};

const id_val_sailing_yacht = /** @type {(inputs: Val_Sailing_YachtInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kapal Pesiar Layar`)
};

const it_val_sailing_yacht = /** @type {(inputs: Val_Sailing_YachtInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Barca a Vela`)
};

const ru_val_sailing_yacht = /** @type {(inputs: Val_Sailing_YachtInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Парусная яхта`)
};

const pt_val_sailing_yacht = /** @type {(inputs: Val_Sailing_YachtInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Veleiro`)
};

const ko_val_sailing_yacht = /** @type {(inputs: Val_Sailing_YachtInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`세일링 요트`)
};

/**
* | output |
* | --- |
* | "Sailing Yacht" |
*
* @param {Val_Sailing_YachtInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const val_sailing_yacht = /** @type {((inputs?: Val_Sailing_YachtInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Val_Sailing_YachtInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_val_sailing_yacht(inputs)
	if (locale === "es") return es_val_sailing_yacht(inputs)
	if (locale === "fr") return fr_val_sailing_yacht(inputs)
	if (locale === "de") return de_val_sailing_yacht(inputs)
	if (locale === "ja") return ja_val_sailing_yacht(inputs)
	if (locale === "zh") return zh_val_sailing_yacht(inputs)
	if (locale === "ar") return ar_val_sailing_yacht(inputs)
	if (locale === "id") return id_val_sailing_yacht(inputs)
	if (locale === "it") return it_val_sailing_yacht(inputs)
	if (locale === "ru") return ru_val_sailing_yacht(inputs)
	if (locale === "pt") return pt_val_sailing_yacht(inputs)
	return ko_val_sailing_yacht(inputs)
});